import CompanyCreditCard from './CompanyCreditCard'

export default CompanyCreditCard
